export enum PesLinkEnum {
  button = 'button',
  link = 'link',
}
